import {
  AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, NgZone, OnInit,
  ViewChild
} from '@angular/core';
import {platformIconPath} from '../../../../app.constants';
import {InfluencerPost} from '../../../../../models/influencer';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'post-image',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './post-image.component.html',
  styleUrls: ['./post-image.component.scss']
})
export class PostImageComponent implements OnInit, AfterViewInit {
  readonly youtubeImageRadio = 94 / 168;
  @ViewChild('postImage') postImage: ElementRef;
  @ViewChild('postImageContainer') postImageContainer: ElementRef;
  @Input() public post: InfluencerPost;

  constructor(private _ngZone: NgZone, private _userService: UserService) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this._ngZone.runOutsideAngular(() => {
      if (!this.post || !this.postImageContainer) {
        return;
      }
      const containerWidth = this.postImageContainer.nativeElement.clientWidth;
      if (this.post.platformId === platformIconPath.youtube.id) {
        this.postImageContainer.nativeElement.style.height = Math.floor(containerWidth * this.youtubeImageRadio) + 'px';
      } else {
        const imageWidth = this.post.imageWidth > 0 ? this.post.imageWidth : this.post.mediaWidth > 0 ? this.post.mediaWidth : 0;
        const imageHeight = this.post.imageHeight > 0 ? this.post.imageHeight : this.post.mediaHeight > 0 ? this.post.mediaHeight : 0;
        if (imageWidth > 0 && imageHeight > 0) {
          this.postImageContainer.nativeElement.style.height = Math.floor((containerWidth * imageHeight) / imageWidth) + 'px';
        } else {
          this.postImageContainer.nativeElement.style.height = Math.floor(containerWidth * 1.25) + 'px';
        }
      }
    });
  }

  onLoadedImage() {
    const postImageContainer = this.postImage.nativeElement.parentElement;
    postImageContainer.classList.add('is-loaded');
  }

  onLoadImageError() {
    const postImageContainer = this.postImage.nativeElement.parentElement;
    postImageContainer.classList.add('is-error');
  }

  hasDimension(post: InfluencerPost) {
    return post && ((post.imageHeight > 0 && post.imageWidth > 0) || (post.mediaHeight > 0 && post.mediaWidth > 0));
  }

  get activeAccount() {
    return this._userService.getCompanyId();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/post-list/post-image/post-image.component.ts